import { useTranslation } from "react-i18next";
import { classNames } from "../../../helpers";
import UserProfilePictureAvatar from "../../avatar/UserProfilePictureAvatar";
import UserTypeBadge from "../../badges/UserTypeBadge";
import MessageStatus from "../../message-status/MessageStatus";

type ChatCardProps = {
  message: string;
  onClick?: (key: any) => void;
  senderName: string;
  senderType: string;
  senderImage?: string;
  unreadMessages?: number;
  active?: boolean;
  lastMessageStatus?: "sent" | "delivered" | "read";
  conversationId: string;
};
export default function ChatCard(props: ChatCardProps) {
  let {
    message,
    active,
    onClick,
    lastMessageStatus,
    senderName,
    senderType,
    senderImage,
    unreadMessages,
    conversationId,
  } = props;
  const { t } = useTranslation("", {
    keyPrefix: "userType",
  });

  return (
    <div
      className={classNames(
        "relative flex items-center gap-2 px-2 py-6 border-b border-gray-200",
        active ? "bg-green-50" : "bg-white"
      )}
      role="button"
      onClick={onClick}
      id={conversationId}
    >
      {!!unreadMessages && unreadMessages > 0 && (
        <span className="absolute inset-y-0 rtl:right-0 ltr:left-0 w-1 bg-brandblue-600" />
      )}
      <div className="flex-shrink-0">
        <UserProfilePictureAvatar
          profilePictureUrl={senderImage}
          className="w-10 h-10"
          alt={senderType}
        />
      </div>
      <div className="w-full flex flex-col gap-0.5">
        <div className="flex items-center justify-between gap-0.5">
          <h5
            className={classNames(
              "text-base font-medium",
              active ? "text-gray-700" : "text-gray-500"
            )}
          >
            {senderType?.toLowerCase() === "supervisor"
              ? t("supervisor")
              : senderName}
          </h5>
          <UserTypeBadge userType={senderType} />
        </div>
        <div className="flex items-center gap-1 justify-between">
          <div className="flex items-center gap-1">
            {!!lastMessageStatus && (
              <MessageStatus status={lastMessageStatus} />
            )}
            <p className="truncate text-xs font-medium text-gray-400 ">
              {message}
            </p>
          </div>
          {!!unreadMessages && unreadMessages > 0 && (
            <span className="min-w-[16px] flex items-center justify-center rounded-full text-white text-[10px] leading-4 font-medium bg-brandblue-500">
              {unreadMessages}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
